import { del, get, post, put } from './request'

interface RefPoint {
    supplier: string;
    propertyId: string;
    property: {
        referencepoint: Array<object>
    };
}

export const getRefPoints = (supplier: string, propertyid: string) => get(`/property/referencepoint?supplier=${supplier}&propertyid=${propertyid}`)
export const addRefPoint = (refPoint: RefPoint) => post('/property/referencepoint', refPoint)
export const updateRefPoint = (refPoint: RefPoint) => put('/property/referencepoint', refPoint)
export const deleteRefPoint = (refPoint: RefPoint) => del('/property/referencepoint', refPoint)

export const addRefPointTransportation = (transportation: RefPoint) => post('/property/refpoint/transportation', transportation)
export const updateRefPointTransportation = (transportation: RefPoint) => put('/property/refpoint/transportation', transportation)
export const deleteRefPointTransportation = (transportation: RefPoint) => del('/property/refpoint/transportation', transportation)